import request from '@/utils/request'


// 查询医生华歧系数变动记录列表
export function listDoctorScoreRrecord(query) {
  return request({
    url: '/doctor/doctorScoreRrecord/list',
    method: 'get',
    params: query
  })
}

// 查询医生华歧系数变动记录分页
export function pageDoctorScoreRrecord(query) {
  return request({
    url: '/doctor/doctorScoreRrecord/page',
    method: 'get',
    params: query
  })
}

// 查询医生华歧系数变动记录详细
export function getDoctorScoreRrecord(data) {
  return request({
    url: '/doctor/doctorScoreRrecord/detail',
    method: 'get',
    params: data
  })
}

// 新增医生华歧系数变动记录
export function addDoctorScoreRrecord(data) {
  return request({
    url: '/doctor/doctorScoreRrecord/add',
    method: 'post',
    data: data
  })
}

// 修改医生华歧系数变动记录
export function updateDoctorScoreRrecord(data) {
  return request({
    url: '/doctor/doctorScoreRrecord/edit',
    method: 'post',
    data: data
  })
}

// 删除医生华歧系数变动记录
export function delDoctorScoreRrecord(data) {
  return request({
    url: '/doctor/doctorScoreRrecord/delete',
    method: 'post',
    data: data
  })
}
